exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".single-button[data-v-40a6ac01] {\n  padding: 8px 16px;\n  margin-left: 2px;\n  border-radius: 12px;\n  border-style: solid;\n  border-width: 1px;\n  border-color: #e6e6e6;\n  color: #3b3b3b;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 16px;\n}\n", ""]);

// exports
